import React from "react";
import aboutImg from "../assets/img/founders.jpg";

import team1 from '../assets/img/Anjali Dadlani.jpg'
import team2 from '../assets/img/siv.jpg'
import team3 from '../assets/img/Rohan Omer.jpg'


const About = () => {
    const team = [
        { img: team1, name: "Anjali Dadlani" },
        { img: team2, name: "Shivanya" },
        { img: team3, name: "Rohan Omer" },
    ];
    return (
        <>
            {/* Inline Theme Styles for Tabs */}
            <style>
                {`
          .nav-tabs .nav-link {
            color: var(--text);
            border: none;
            border-bottom: 3px solid transparent;
            background: transparent;
            transition: all 0.3s ease;
          }

          .nav-tabs .nav-link.active {
            color: var(--primary);
            font-weight: 600;
            border-bottom: 3px solid var(--secondary);
            background: var(--light-bg);
          }

          .nav-tabs .nav-link:hover {
            color: var(--primary);
          }

          .tab-content {
            color: var(--text);
          }
        `}
            </style>

            {/* <Breadcrumb currentName={"About"} currentParentName={"About"} /> */}
            {/* ===== About Section ===== */}
            <section
                className="container-xxl "
                style={{ backgroundColor: "var(--light-bg)", padding: "150px 0 0 0", }}
            >
                <div className="container">
                    <h5
                        className="d-inline-block border rounded fw-bold py-1 px-3 mb-3 story"
                        style={{
                            color: "var(--primary)",
                            borderColor: "var(--primary)",
                            backgroundColor: "var(--white)",
                        }}
                    >
                        Our Story
                    </h5>
                    <section
                        className="container-xxl"
                        style={{ backgroundColor: "var(--light-bg)", padding: "10px 0 0 0" }}
                    >
                        <div className="container">
                            <div className="row g-1 align-items-stretch">

                                {/* LEFT IMAGE (equal height) */}
                                <div className="col-lg-6 pe-lg-3 d-flex">
                                    <img
                                        className="img-fluid rounded shadow-sm w-100 h-100"
                                        src={aboutImg}
                                        alt="SAG Financials Office"
                                        style={{
                                            border: "4px solid var(--secondary)",
                                            objectFit: "cover"
                                        }}
                                    />
                                </div>

                                {/* RIGHT TEXT (equal height) */}
                                <div className="col-lg-6 ps-lg-3 d-flex">

                                    <div className="p-2 w-100 d-flex flex-column" style={{ border: "2px solid var(--primary)" }}>



                                        <div className="mb-2" style={{ color: "var(--text)" }}>
                                            <p className="mb-2">
                                                <strong>SAG Financials</strong> helps individuals & families achieve their financial
                                                goals through transparent, digital-first & personalized planning solutions.
                                            </p>

                                            <p className="mb-2">
                                                We understand that financial planning is not just about numbers; it's about people,
                                                their aspirations & their life goals.
                                            </p>

                                            <p className="mb-0">
                                                Established in <strong>2017</strong>, our mission is to simplify finance & empower
                                                people to build long-term wealth, protection & security with trust & clarity.
                                            </p>
                                        </div>

                                        {/* Tabs */}
                                        <div
                                            className="border-top rounded p-3 mt-3 adjustsize"
                                            style={{
                                                borderColor: "var(--secondary) !important",
                                                backgroundColor: "var(--white)",
                                                height: 320
                                            }}
                                        >
                                            <nav>
                                                <div
                                                    className="nav nav-tabs mb-3 justify-content-center justify-content-md-start"
                                                    id="nav-tab"
                                                    role="tablist"
                                                >
                                                    <button
                                                        className="nav-link active fw-semi-bold"
                                                        id="nav-story-tab"
                                                        data-bs-toggle="tab"
                                                        data-bs-target="#nav-story"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="nav-story"
                                                        aria-selected="true"
                                                    >
                                                        How We Started
                                                    </button>

                                                    <button
                                                        className="nav-link fw-semi-bold"
                                                        id="nav-mission-tab"
                                                        data-bs-toggle="tab"
                                                        data-bs-target="#nav-mission"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="nav-mission"
                                                        aria-selected="false"
                                                    >
                                                        Our Founder
                                                    </button>

                                                    <button
                                                        className="nav-link fw-semi-bold"
                                                        id="nav-vision-tab"
                                                        data-bs-toggle="tab"
                                                        data-bs-target="#nav-vision"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="nav-vision"
                                                        aria-selected="false"
                                                    >
                                                        In Her Words
                                                    </button>
                                                </div>
                                            </nav>


                                            <div className="tab-content" id="nav-tabContent">

                                                {/* How We Started */}
                                                <div
                                                    className="tab-pane fade show active"
                                                    id="nav-story"
                                                    role="tabpanel"
                                                    aria-labelledby="nav-story-tab"
                                                >
                                                    <p className="mb-2">
                                                        <strong>SAG Financials</strong> was born out of both expertise and empathy.
                                                    </p>

                                                    <p className="mb-2">
                                                        In 2017, <strong>Shepra Anand</strong> founded <strong>SAG Financials</strong>.
                                                    </p>

                                                    <p className="mb-2">
                                                        With 22+ years of financial industry experience, our foundation is backed by her strong
                                                        expertise and professional certifications. Her journey began with leading corporate financial
                                                        institutions like ICICI Bank, IDBI Federal Life, Aditya Birla Sun Life, and Religare
                                                        Broking, before shaping into a client-first advisory platform.
                                                    </p>

                                                    <p className="mb-0">
                                                        Since then, we have helped hundreds of clients plan smarter & live more securely.
                                                    </p>
                                                </div>

                                                {/* Our Founder */}
                                                <div
                                                    className="tab-pane fade"
                                                    id="nav-mission"
                                                    role="tabpanel"
                                                    aria-labelledby="nav-mission-tab"
                                                >
                                                    <p className="mb-2">
                                                        <strong>Shepra Anand</strong>, CEO & Founder, Financial Goal Planner with 22+ years in the financial industry,
                                                        AMFI, IRDA & NISM certified.
                                                    </p>
                                                    <ul className="mb-0">
                                                        <li>Track Record of Top performer in corporate financial institution</li>
                                                        <li>2× MDRT- An achievement of International recognition </li>
                                                        <li>2× Felicitation at International convention at Phuket & Istanbul</li>
                                                        <li>Train the Trainer Certification by Aditya Birla Sun Life</li>               
                                                        <li>3× Felicitation by IDBI Federal Life CEO at National Conventions</li>
                                                        <li>5× Gold & Platinum Club recognition by Aditya Birla Sun Life</li>

                                                    </ul>
                                                </div>

                                                {/* In Her Words */}
                                                <div
                                                    className="tab-pane fade"
                                                    id="nav-vision"
                                                    role="tabpanel"
                                                    aria-labelledby="nav-vision-tab"
                                                >
                                                    <p style={{ fontStyle: "italic" }} className="mb-2">
                                                        "Right Financial Planning done at right time leads to Financial Freedom.
                                                        Financial Freedom leads to comfortable Life."
                                                    </p>
                                                    <p className="mb-0" style={{ color: "var(--heading)" }}>
                                                        <strong>— Shepra Anand, CEO & Founder, SAG Financials</strong>
                                                    </p>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>



                    {/* ===== Feature Section ===== */}
                    <div
                        className="border rounded p-4 d-none"
                        style={{
                            borderColor: "var(--secondary)",
                            backgroundColor: "var(--white)",
                        }}
                    >
                        <div className="row g-4 ">
                            {[
                                {
                                    icon: "fa-heart",
                                    title: "Personalized Advice",
                                    text: "We focus on people, not products — offering guidance that fits your life and goals.",
                                },
                                {
                                    icon: "fa-users",
                                    title: "Trusted Expertise",
                                    text: "Over two decades of experience with top financial institutions, delivered with empathy.",
                                },
                                {
                                    icon: "fa-handshake",
                                    title: "Relationships That Last",
                                    text: "We believe in lifelong relationships built on trust, clarity, and care.",
                                },
                            ].map((item, i) => (
                                <div key={i} className="col-lg-4">
                                    <div className="d-flex align-items-start">
                                        <div
                                            className="flex-shrink-0 btn-lg-square rounded-circle"
                                            style={{
                                                backgroundColor: "var(--primary)",
                                                width: "50px",
                                                height: "50px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <i
                                                className={`fa ${item.icon}`}
                                                style={{ color: "var(--white)" }}
                                            ></i>
                                        </div>
                                        <div className="ps-3">
                                            <h4 style={{ color: "var(--heading)" }}>{item.title}</h4>
                                            <span style={{ color: "var(--text)" }}>{item.text}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </section>
            {/* ===== Team Philosophy ===== */}
            <section
                className="container-xxl "
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">


                    <section
                        className="container-xxl py-5"
                        style={{ backgroundColor: "var(--light-bg)" }}
                    >
                        <div className="container">
                            <div
                                className="text-center mx-auto"
                                style={{ maxWidth: "600px" }}
                            >
                                <h5
                                    className="d-inline-block border rounded fw-bold py-1 px-3 mb-3"
                                    style={{
                                        color: "var(--primary)",
                                        borderColor: "var(--primary)",
                                        backgroundColor: "var(--white)",
                                    }}
                                >
                                    Our Exclusive Team
                                </h5>

                            </div>

                            <div className="row g-4">
                                {team.map((member, i) => (
                                    <div
                                        key={i}
                                        className="col-lg-4 col-md-6"
                                        style={{
                                            animation: "fadeInUp 0.8s ease",
                                            animationDelay: `${0.1 + i * 0.2}s`,
                                        }}
                                    >
                                        <div
                                            className="rounded overflow-hidden shadow-sm"
                                            style={{
                                                border: "3px solid var(--secondary)",
                                                borderRadius: "12px",
                                                backgroundColor: "var(--white)",
                                                transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = "translateY(-8px)";
                                                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.15)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = "translateY(0)";
                                                e.currentTarget.style.boxShadow = "none";
                                            }}
                                        >
                                            <img
                                                className="img-fluid rounded w-100"
                                                src={member.img}
                                                alt={member.name}
                                                style={{
                                                    objectFit: "cover",
                                                    borderBottom: "3px solid var(--secondary)",
                                                    height: 320
                                                }}
                                            />


                                        </div>
                                        <div
                                            className="team-text text-center py-3"
                                            style={{ backgroundColor: "var(--white)" }}
                                        >
                                            <h4
                                                className="mb-0"
                                                style={{ color: "var(--heading)", fontWeight: "600" }}
                                            >
                                                {member.name}
                                            </h4>


                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    <div className="row g-4 mb-5 d-none">
                        <div className="col-lg-6">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                Every Member of Our Team
                            </h4>
                            <ul className="list-unstyled" style={{ color: "var(--text)" }}>
                                <li>• Certified by AMFI, IRDA, or NISM</li>
                                <li>• Committed to client-first advisory</li>
                                <li>• Clear and empathetic communication</li>
                                <li>• Passionate about simplifying finance</li>
                            </ul>
                        </div>

                        <div className="col-lg-6">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                What We Stand For
                            </h4>
                            <ul className="list-unstyled" style={{ color: "var(--text)" }}>
                                <li>🌱 Clarity Over Complexity</li>
                                <li>🤝 Relationships Over Transactions</li>
                                <li>💡 Education Over Pressure</li>
                                <li>🌍 Digital by Design, Human at Heart</li>
                            </ul>
                        </div>
                    </div>

                    <div className="row g-4 mb-5 d-none">
                        <div className="col-lg-12">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                Our Clients, Our Community
                            </h4>
                            <p style={{ color: "var(--text)" }}>
                                We’re honored to serve professionals, families, retirees, and
                                entrepreneurs — all seeking financial clarity and confidence.
                            </p>
                        </div>
                    </div>

                    <div className="row g-4 d-none">
                        <div className="col-lg-12">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                Looking Forward
                            </h4>
                            <p style={{ color: "var(--text)" }}>
                                As we continue to grow, our mission remains the same: to be your
                                lifelong financial partner — today, tomorrow, and beyond.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
